<template>
  <Tooltip
    :text="tooltip"
    :hide-delay="200"
  >
    <div
      class="btn-group btn-group-sm debug-locale-switcher"
      role="group"
      :aria-label="groupLabel"
    >
      <button
        type="button"
        class="btn btn-outline-secondary"
        :class="{ active: current === 'ru' }"
        :aria-pressed="current === 'ru'"
        @click="setLocale('ru')"
      >
        RU
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        :class="{ active: current === 'en' }"
        :aria-pressed="current === 'en'"
        @click="setLocale('en')"
      >
        EN
      </button>
    </div>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Tooltip from '@/components/tooltip.vue'
import { i18n } from '@/i18n'
import { persistUserLocalePreference } from '@/i18n/localeStorage.js'
import { useUserStore } from '@/stores/user'

const { t } = useI18n()
const userStore = useUserStore()
const current = computed(() => i18n.global.locale.value)

/**
 * Переключает только язык UI (localStorage). preferred_locale в SSO не меняет.
 *
 * @param {'en'|'ru'} code код локали
 * @returns {void}
 */
function setLocale(code) {
  i18n.global.locale.value = persistUserLocalePreference(userStore.user?.id, code)
}

const tooltip = computed(() => t('tooltip'))
const groupLabel = computed(() => t('groupLabel'))
</script>

<i18n>
{
  "ru": {
    "tooltip": "Язык интерфейса",
    "groupLabel": "Язык интерфейса"
  },
  "en": {
    "tooltip": "Interface language",
    "groupLabel": "Interface language"
  }
}
</i18n>

<style scoped>
.debug-locale-switcher .btn.active {
  --bs-btn-active-bg: rgba(255, 255, 255, 0.2);
  --bs-btn-active-border-color: rgba(255, 255, 255, 0.35);
  --bs-btn-active-color: #fff;
}
</style>
